import React from "react";

const PaperClip = ({ className }) => (
  <svg
    width="52px"
    height="48px"
    viewBox="0 0 52 48"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M52.1 34.7c-1.1-3.1-3-5.8-5.5-7.7l-5.1-5.1-2.2-2.2c-5-5-10-10-14.9-15-2.9-3.1-7-4.9-11.3-4.7C6.7.2 1.3 4.9.2 11.3c-.9 4.9.8 9.9 4.5 13.2 6.6 6.7 13.4 13.4 20 19.9.7.7 1.8.7 2.5 0s.7-1.8 0-2.5c-6.6-6.5-13.3-13.2-20-20-2.8-2.6-4.1-6.3-3.4-10.1.8-4.7 4.8-8.2 9.5-8.3 3.2-.1 6.4 1.2 8.6 3.6l15 15 2.2 2.2c1.7 1.7 3.4 3.4 5.3 5.2 2 1.6 3.6 3.8 4.4 6 .8 4-1.7 7.9-5.7 8.7-.8.2-1.6.2-2.4.1-1.9-.4-3.6-1.3-4.9-2.7L17.7 23.5c-1.3-1.1-2.3-2.6-2.7-4-.2-1.4.4-2.7 1.6-3.4 1.4-1 3.2-.9 4.4.1l6.9 6.9 3.3 3.3c.7.7 1.8.7 2.5 0s.7-1.8 0-2.5l-3.3-3.3c-2.3-2.3-4.6-4.5-7-6.9-2.5-2.1-6.1-2.3-8.8-.4-2.2 1.5-3.4 4.1-3.1 7 .6 2.4 2 4.5 3.8 6l17.9 17.9c1.8 1.9 4.2 3.2 6.9 3.7.5.1 1 .1 1.4.1.7 0 1.5-.1 2.2-.2 5.9-1.2 9.7-7 8.4-13.1z" />
  </svg>
);

export default PaperClip;
